import devConfig from 'src/config/config_dev';
import prodConfigs from 'src/config/config_prod';
import stageConfigs from 'src/config/config_stage';

import { isStandard, getTenantRedirectUri } from '../multi-tenant-uri';

export const isDev = () => {
  const { origin } = window.location;
  return (
    origin.includes('localhost') ||
    origin === 'https://react-m-dev.clp.kr' ||
    origin.includes('-dev')
  );
};

/**
 * 환경(개발/스테이지/운영)을 결정하는 함수
 */
const getEnvConfig = () => {
  // 개발
  if (isDev()) return devConfig;

  // 스테이지
  if (origin.includes('.stage.')) return stageConfigs;

  // 운영
  return prodConfigs;
};

/**
 * URL에서 고객사 코드를 추출하는 함수 (첫 번째 segment)
 */
export const getConfigBrandCode = (): string | null => {
  try {
    return getTenantRedirectUri();
  } catch (e) {
    console.error('getConfigBrandCode Error:', e);
    return null;
  }
};

/**
 * 환경 및 고객사 코드를 기반으로 최종 config를 조회하는 함수
 */
export const getRuntimeConfig = () => {
  const envConfig = getEnvConfig();

  // localhost 환경에서는 첫 번째 설정을 기본으로 사용
  if (window.location.origin.includes('localhost') || process.env.NODE_ENV === 'development') {
    return envConfig[0] || null;
  }

  // 고객사별 config 조회
  const configBrandCode = getConfigBrandCode();

  // envConfig 객체에서 고객사코드(BRAND_CODE)로 데이터 탐색
  const companyConfig = envConfig.find((item) => item.BRAND_CODE === configBrandCode);

  if (!companyConfig) {
    console.error(`Config not found for brand: ${configBrandCode}`);
    return null;
  }

  return companyConfig;
};

/**
 * 로컬/개발 환경에서 isStandard() 결과에 따라 동적으로 API 호스트를 결정하는 함수
 */
export const getDynamicApiHost = (runtimeConfig: any): string => {
  // 운영환경에서는 기존 로직 유지
  if (!isDev()) {
    return runtimeConfig?.VUE_APP_API_HOST ?? '';
  }

  // 로컬/개발 환경에서만 동적 변경
  try {
    if (isStandard()) {
      return runtimeConfig?.VUE_APP_API_HOST_STANDARD ?? 'https://api-dev.clp.kr/anchor/';
    }
    return runtimeConfig?.VUE_APP_API_HOST_ENTERPRISE ?? 'https://api-dev.clp.kr/anchor/';
  } catch (error) {
    // isStandard() 호출 시 오류가 발생하면 기본값 사용
    console.warn('getDynamicApiHost: isStandard() 호출 실패, 기본값 사용:', error);
    return runtimeConfig?.VUE_APP_API_HOST ?? '';
  }
};
